module.exports = __webpack_public_path__ + "static/media/rebirth_13.73c9b4df.jpg";